import { useTemperature } from '../../hooks/useTemperature';
import { Button, ButtonHole, ButtonTop, Img } from './bodyStyles';
import {
  ControllerTitle,
  InstantHeatInner,
  InstantHeatWrapper,
  SnowSensorInner,
  SnowSensorWrapper,
  TempInput,
} from './electricControlStyles';
import { programImage } from './machineCardFacts';

/** The collapsed ESS/TES card's instant heat field and snow sensor button. */
const ElectricControls = ({
  device,
  programsLocked: locked,
  instantTemp,
  editInstantTemp,
  submitInstantHeat,
  toggleSnowSensor,
}) => {
  const { instantHeat, snowSensor } = device;
  const { isF } = useTemperature();

  return (
    <>
      <InstantHeatWrapper onSubmit={submitInstantHeat} isOff={locked}>
        <InstantHeatInner
          isActivated={instantHeat.isActivated}
          isReady={instantHeat.isReady}
          isOff={locked}
        >
          <Button onClick={submitInstantHeat} isActivated={instantHeat.isActivated} isOff={locked}>
            <ButtonHole
              isActivated={instantHeat.isActivated}
              isReady={instantHeat.isReady}
              isOff={locked}
            >
              <ButtonTop isActivated={instantHeat.isActivated} isOff={locked}>
                <Img src={programImage('instantHeat', locked)} />
              </ButtonTop>
            </ButtonHole>
          </Button>

          <ControllerTitle isOff={locked}>
            instant <br></br> heat
          </ControllerTitle>

          <TempInput
            type='text'
            placeholder={isF ? '0 °F' : '0 °C'}
            value={instantTemp}
            onChange={(e) => editInstantTemp(e.target.value)}
            isActivated={instantHeat.isActivated}
            isOff={locked}
          />
        </InstantHeatInner>
      </InstantHeatWrapper>

      <SnowSensorWrapper isOff={locked}>
        <SnowSensorInner
          isActivated={snowSensor.isActivated}
          isReady={snowSensor.isReady}
          isOff={locked}
        >
          <Button onClick={toggleSnowSensor} isOff={locked}>
            <ButtonHole isOff={locked}>
              <ButtonTop isOff={locked}>
                <Img src={programImage('snowSensor', locked)} />
              </ButtonTop>
            </ButtonHole>
          </Button>

          <ControllerTitle isOff={locked}>
            snow <br></br> sensor
          </ControllerTitle>
        </SnowSensorInner>
      </SnowSensorWrapper>
    </>
  );
};

export default ElectricControls;
